/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// utils
import { url } from 'utils/urls';
// material
import Space from 'material/space/space';
import { SectionGroupV2 } from 'material/expandablesection/v2'
import { ConfigToggle } from 'material/expandablesection/v2'
import PreviewConfig from 'material/previewconfig/previewconfig'
import ArticleCard from 'material/articlecard/articleccard'

// styles
import injectSheet from 'react-jss'
import styles from './engagementcounters_styles'

/* ========== ~~~~~~~~~~ COMMENTING CONFIG V2: GENERAL SECTION : ENGAGEMENT COUNTERS ~~~~~~~~~~ ========== */
const EngagementCounters = injectSheet(styles)((props) => {

  const { showCommentsCount, showReactionsCount, showViewsCount, onChange } = props

  const handleEngagementCountersChange = (newProperty) => {
    const currentProperties = {
      showCommentsCount,
      showReactionsCount,
      showViewsCount
    }
    onChange({ engagementCounters: {...currentProperties, ...newProperty}})
  }

  return (
    <SectionGroupV2 
      indented={true} 
      klass={`sortconfig ${props.classes.sortconfig}`} 
      title={'Engagement counters'} 
      description={'Display statistics from commenting unit and/or article sentiment products on each article preview.'}
      rowGap={32} 
      direction={'column'}>
        <Space gap={48}>
          <Space gap={16} direction={'column'}>
            <ConfigToggle 
              title={'Allow number of comments'}
              description={'Show or hide the total number of comments in the commenting unit.'}
              checked={showCommentsCount}
              onChange={val => handleEngagementCountersChange({ showCommentsCount: val})}
            />
            <ConfigToggle 
              title={'Allow number of reactions'}
              description={'Show or hide the total number of emoji reactions from commenting unit.'}
              checked={showReactionsCount}
              onChange={val => handleEngagementCountersChange({ showReactionsCount: val})}
            />
            <ConfigToggle 
              title={'Allow number of page views'}
              description={'Show or hide the total number of article page views.'}
              checked={showViewsCount}
              onChange={val => handleEngagementCountersChange({ showViewsCount: val})}
            />
          </Space>
          <PreviewConfig>
            <ArticleCard 
              title={'Sample article headline from your site'} 
              totalComments={showCommentsCount ? 32 : null}
              totalReactions={showReactionsCount ? 96 : null}
              totalViews={showViewsCount ? '1k' : null}
              imageSrc={`${url.image}/2.0/trendingnow/article-image-1.jpg`}
            />
          </PreviewConfig>
        </Space>
    </SectionGroupV2>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default EngagementCounters;